<template>
  <Dialog
    :class="$i18n.locale"
    :visible.sync="visible"
    :title="options.title"
    :confirmText="options.confirmText"
    :cancelText="options.cancelText"
    :showClose="!options.hideClose"
    @confirm="handleConfirm"
    @cancel="handleCancel"
    @touchmove.native.prevent
  >
    <template #title v-if="options.icon">
      <div class="custom-header" :class="options.icon">
        <div class="custom-header-title">{{ options.title }}</div>
      </div>
    </template>
    <div class="confirm-content" :class="{ 'confirm-ar': $i18n.locale === 'AR' }">
      <p v-if="options.contentHtml" @touchmove.stop v-touchmove v-html="options.content"></p>
      <p v-else @touchmove.stop v-touchmove>{{ options.content }}</p>
    </div>
  </Dialog>
</template>

<script>
export default {
  name: 'Confirm',
  data() {
    return {
      visible: false,
      options: {
        title: this.$t('game.notice'),
        content: '',
        confirmText: this.$t('game.confirm'),
        cancelText: this.$t('game.orderCancel'),
        confirm: () => {},
        cancel: () => {},
        icon: '',
        hideClose: false,
        contentHtml: false,
      },
    }
  },
  methods: {
    handleConfirm() {
      this.close()
      this.options.confirm()
    },
    handleCancel() {
      this.close()
      this.options.cancel()
    },
    close() {
      this.visible = false
    },
    open(options) {
      this.options = {
        title: options.title || this.$t('game.notice'),
        content: options.content || '',
        confirmText: options.confirmText || this.$t('game.confirm'),
        cancelText: options.cancelText || this.$t('game.orderCancel'),
        confirm: options.confirm || (() => {}),
        cancel: options.cancel || (() => {}),
        icon: options.icon || '',
        hideClose: options.hideClose || false,
        contentHtml: !!options.contentHtml,
      }
      if (options.hideCancel) {
        this.options.cancelText = ''
      }
      if (options.hideConfirm) {
        this.options.confirmText = ''
      }
      this.visible = true
    },
  },
}
</script>

<style lang="less" scoped>
.confirm-content {
  border-radius: 8px;
  background: rgba(242, 244, 248, 1);
  font-size: 16px;
  line-height: 1.3;
  color: rgba(52, 58, 63, 1);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80px;
  p {
    max-height: 300px;
    overflow-y: auto;
    height: 100%;
    text-align: center;
    padding: 12px;
  }
  ::v-deep .confirm-content-email {
    color: #1bc263;
    word-break: break-word;
  }

  /* $confirm 挂在 body 上，不在 #app.rtl 内；阿语下用独立 LTR 块稳定邮箱双向排版 */
  &.confirm-ar ::v-deep .confirm-content-email {
    direction: ltr;
    unicode-bidi: isolate;
  }
}
</style>
